import { useTheme } from 'next-themes';
import React from 'react';
import { Switch } from '@radix-ui/react-switch';
import { useCustomTheme } from '../../contexts/ThemeContext';
import { Sun, Moon } from 'lucide-react';

interface ThemeToggleProps {
  small?: boolean;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ small = false }) => {
  const { theme, setTheme } = useTheme();
  const { applyThemeColors } = useCustomTheme();

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    applyThemeColors();
  };

  return (
    <div className="flex items-center space-x-2">
      <Switch
        checked={theme === 'dark'}
        onCheckedChange={toggleTheme}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-theme-40 focus-visible:ring-offset-2 focus-visible:ring-offset-theme-10 disabled:pointer-events-none disabled:opacity-50 data-[state=checked]:bg-theme-20 data-[state=unchecked]:bg-theme-10 ${small ? 'h-4 w-8' : 'h-6 w-11'}`}
      >
        <span className={`inline-block transform rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0 ${small ? 'h-3 w-3' : 'h-5 w-5'}`}>
          {theme === 'dark' ? (
            <Sun className={`${small ? 'h-2 w-2' : 'h-3 w-3'} m-auto`} />
          ) : (
            <Moon className={`${small ? 'h-2 w-2' : 'h-3 w-3'} m-auto`} />
          )}
        </span>
      </Switch>
    </div>
  );
};